import { useQuery } from "@tanstack/react-query";
import {
  getDashboardPlants,
  getFleetOverview,
  getPlantOverview,
  type FleetSelection,
} from "../api/dashboard";

export function useFleetOverview(selection: FleetSelection) {
  return useQuery({
    queryKey: ["dashboard", "fleet", selection],
    queryFn: () => getFleetOverview(selection),
    placeholderData: (previous) => previous,
  });
}

export function useDashboardPlants() {
  return useQuery({
    queryKey: ["dashboard", "plants"],
    queryFn: getDashboardPlants,
  });
}

export function usePlantOverview(
  plantId: string | null,
  selection: FleetSelection,
) {
  return useQuery({
    queryKey: ["dashboard", "overview", plantId, selection],
    queryFn: () => getPlantOverview(plantId!, selection),
    enabled: !!plantId,
    placeholderData: (previous) => previous,
  });
}
